import gql from 'graphql-tag';
// import { AssetImageSubtype } from 'src/modules/assets';

export const FRAGMENT_DESIGNER_CARD = gql`
  fragment designerCardFields on Designer {
    name
    slug
    assets(where: { subtype: "picture.personPortrait." }, limit: 1) {
      subtype
      format_3x2 {
        url
        formats
        alternativeText
      }
    }
  }
`;

export const QUERY_DESIGNERS_LISTING = gql`
  query Designers {
    designers(sort: "ranking:asc") {
      ...designerCardFields
    }
  }
  ${FRAGMENT_DESIGNER_CARD}
`;
